<div *ngIf="isLoading"
    style="flex: 1 0 100%; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
    <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="ms-notifications-details-spinner-1" site="s"></sh-spinner>
    </div>
</div>

<div class="layout" *ngIf="!isLoading">

    <!-- Error State -->
    <div *ngIf="isError"
        style="flex: 1; min-height: 0;grid-row: span 2;">
        <sh-empty-state id="ms-notifications-details-empty-state-please-try-again-later" [attr.header]="'notificationDetails.error.header' | transloco" [attr.label]="'notificationDetails.error.message' | transloco" icon="error"
            icon-color="ebebeb"></sh-empty-state>
    </div>

    <!-- Site Activities Table -->
    <div style="flex: 1 0 auto; min-height: 0;" *ngIf="!isError">
        <p-table [size]="'small'" #table [value]="notificationDetails.details.visits"
            [scrollable]="true" scrollHeight="flex">

            <!-- Tools -->
            <ng-template #caption style="border: none;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <sh-text id="ms-notifications-details-text-3" size="title-1">{{ 'notificationDetails.serviceActivities.title' | transloco }}</sh-text>

                    <div class="table-tools" style="flex: 1 1 40%; gap: 8px; align-items: center;">

                        <p-columnFilter style="flex: 0 1 auto;" type="text" [showMenu]="false" field="activity_type"
                            matchMode="contains">
                            <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                <sh-search id="ms-notifications-details-search-search-for-activity" no-border [attr.label]="'notificationDetails.serviceActivities.filter' | transloco" condensed [(ngModel)]="searchTerm"
                                    (ngModelChange)="filter($event)"></sh-search>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </div>



            </ng-template>

            <!-- Header -->
            <ng-template #header>
                <tr>
                    <th pSortableColumn="activity_type" style="min-width:200px;" pFrozenColumn>
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.serviceActivities.activityType' | transloco }}
                            <p-sortIcon field="activity_type" />
                        </div>
                    </th>
                    <th pSortableColumn="start_date" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.serviceActivities.startDate' | transloco }}
                            <p-sortIcon field="start_date" />
                        </div>
                    </th>
                    <th pSortableColumn="end_date" style="min-width:12px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.serviceActivities.endDate' | transloco }}
                            <p-sortIcon field="end_date" />
                        </div>
                    </th>


                </tr>
            </ng-template>
            <ng-template #body let-part>
                <tr>
                    <td pFrozenColumn><span [innerHTML]="highlight(part.activity_type)"></span></td>
                    <td>{{part.start_date?.replace("T"," ")?.replace("Z","")}}</td>
                    <td>{{part.end_date?.replace("T"," ")?.replace("Z","")}}</td>
                </tr>

            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div *ngIf="!isError"
                            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                            <sh-icon id="ms-notifications-details-icon-warning" icon="warning" size="s"></sh-icon>
                            <span>{{ 'common.empty.noData' | transloco }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Spare Parts Table -->
    <div *ngIf="!isError" >
        <p-table [size]="'small'" #table [value]="notificationDetails.details.parts"
            [scrollable]="true" scrollHeight="flex">

            <!-- Tools -->
            <ng-template #caption style="border: none;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <sh-text id="ms-notifications-details-text-6" size="title-1">{{ 'notificationDetails.usedParts.title' | transloco }}</sh-text>

                    <div class="table-tools" style="flex: 1 1 40%; gap: 8px; align-items: center;">

                        <p-columnFilter style="flex: 0 1 auto;" type="text" [showMenu]="false" field="parts_replaced"
                            matchMode="contains">
                            <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                <sh-search id="ms-notifications-details-search-search-for-part" no-border [attr.label]="'notificationDetails.usedParts.filter' | transloco" condensed [(ngModel)]="searchTermParts"
                                    (ngModelChange)="filter($event)"></sh-search>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </div>



            </ng-template>

            <!-- Header -->
            <ng-template #header>
                <tr>
                    <th pSortableColumn="parts_replaced" style="min-width:175px;" pFrozenColumn>
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.usedParts.sparePart' | transloco }}
                            <p-sortIcon field="parts_replaced" />
                        </div>
                    </th>
                    <th pSortableColumn="movement_date" style="min-width:110px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.usedParts.date' | transloco }}
                            <p-sortIcon field="movement_date" />
                        </div>
                    </th>
                    <th *ngIf="!businessPartnerMode" pSortableColumn="parts_cost" style="min-width:75px; text-align: right;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.usedParts.cost' | transloco }}
                            <p-sortIcon field="parts_cost" />
                        </div>
                    </th>
                    <th pSortableColumn="parts_consumed" style="min-width:12px; text-align: right;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'notificationDetails.usedParts.quantity' | transloco }}
                            <p-sortIcon field="parts_consumed" />
                        </div>
                    </th>
                    <th alignFrozen="right" pFrozenColumn></th>

                </tr>
            </ng-template>
            <ng-template #body let-part>
                <tr>
                    <td pFrozenColumn><span [innerHTML]="highlightParts(part.parts_replaced)"></span></td>
                    <td>{{part.movement_date?.replace("T"," ")?.replace("Z","")}}</td>
                    <td *ngIf="!businessPartnerMode" style="text-align: right;">{{part.parts_cost}}</td>
                    <td style="text-align: right;">{{part.parts_consumed}}</td>
                    <td alignFrozen="right" pFrozenColumn>
                        <div style="display: flex; gap: 6px; justify-content: center; align-items: center;">
                            <sh-button id="ms-notifications-details-button-how-to-replace" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'" compact
                                [attr.label]="'notificationDetails.usedParts.howToReplace' | transloco" size="m" color="tertiary"
                                (click)="askChat(part)"></sh-button>
                        </div>
                    </td>
                </tr>

            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div *ngIf="!isError"
                            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                            <sh-icon id="ms-notifications-details-icon-warning" icon="warning" size="s"></sh-icon>
                            <span>{{ 'common.empty.noData' | transloco }}</span>
                        </div>
                        <div *ngIf="isError"
                            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                            <sh-icon id="ms-notifications-details-icon-error" icon="error" size="s"></sh-icon>
                            <span>{{ 'common.empty.error' | transloco }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #footer>
                <tr>
                    <td colspan="2" pFrozenColumn>{{ 'notificationDetails.usedParts.totals' | transloco }}</td>
                    <td *ngIf="!businessPartnerMode" class="font-bold" style="text-align: right;">{{ retrieveTotalCost() }}</td>
                    <td class="font-bold" style="text-align: right;">{{ retrieveTotalQuantity() }}</td>
                    <td colspan="1"></td>
                    <!-- <td alignFrozen="right" pFrozenColumn></td> -->
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- AI Notification Summary & Orig Text-->
    <div style="grid-column: 2; grid-row: 1 / span 2; overflow-y: auto;">
        <sh-box id="ms-notifications-details-box-11" style="height: 100%; flex: 1 1 400px;" background="surface-secondary" padding="compact"
            layout="vertical">
            <sh-box-header id="ms-notifications-details-box-header-12" slot="header" padding-top="10px">
                <sh-tabs id="ms-notifications-details-tabs-13" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'">
                    <sh-tab-item id="ms-notifications-details-tab-item-ai-notification-summary" class="custom-tab-item" [attr.label]="'notificationDetails.tab.aiSummary' | transloco" icon="ai-generative" size="l"
                        [active]="selectedTab===0" (click)="switchTab(0)"></sh-tab-item>
                    <sh-tab-item id="ms-notifications-details-tab-item-original-text" [attr.label]="'notificationDetails.tab.originalText' | transloco" size="m" icon-size="s" [active]="selectedTab===1"
                        (click)="switchTab(1)"></sh-tab-item>
                </sh-tabs>
            </sh-box-header>
            <sh-box-section id="ms-notifications-details-box-section-16" padding-top="0px" [style.display]="selectedTab===0 ? 'block' : 'none'">
                <div *ngIf="isSummaryLoading"
                    style="flex: 1 0 100%; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
                    <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
                        <sh-spinner id="ms-notifications-details-spinner-17" site="s"></sh-spinner>
                    </div>
                </div>
                <app-timeline *ngIf="!isSummaryLoading && !isSummaryError && notificationSummary"
                    [timeline]="notificationSummary"></app-timeline>
                <sh-empty-state id="ms-notifications-details-empty-state-please-try-again-later" *ngIf="!isSummaryLoading && isSummaryError" style="height: 100%"
                    [attr.header]="'notificationDetails.aiSummary.error.header' | transloco" [attr.label]="'notificationDetails.aiSummary.error.message' | transloco" icon="error"
                    icon-color="ebebeb"></sh-empty-state>
            </sh-box-section>
            <sh-box-section id="ms-notifications-details-box-section-19" padding-top="0px" [style.display]="selectedTab===1 ? 'block' : 'none'">
                <sh-text id="ms-notifications-details-text-20" *ngIf="!isLoading && !isError && notificationDetails"
                    style="white-space: pre-line">{{notificationDetails.details.summary}}
                </sh-text>

                <div *ngIf="!isLoading && isError"
                    style="flex: 1 0 100%; height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
                    <sh-empty-state id="ms-notifications-details-empty-state-please-try-again-later" [attr.header]="'notificationDetails.error.header' | transloco" [attr.label]="'notificationDetails.error.message' | transloco"
                        icon="error" icon-color="ebebeb"></sh-empty-state>
                </div>
            </sh-box-section>


        </sh-box>
    </div>
</div>